import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const HandleQueryError = withAsync({
	loader: lazyForPaint(
		() => import(/* webpackChunkName: 'async-handle-query-error' */ './handle-query-error'),
	),
	LoadingSkeleton: () => null,
});
